import React from "react"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography"

const HeadCell = ({ columnMeta, updateDirection, jumpColDef }) => {
  const { label, index } = columnMeta
  if (label.match(/<.+>.+<.+>/)) {
    return (
      /* necessary because reports can have html embeded */
      /* eslint-disable-next-line react/no-danger */
      <th
        className="MuiTableCell-head MuiTableCell-root"
        aria-label="header"
        dangerouslySetInnerHTML={{ __html: label }}
        key={index}
        onClick={() => updateDirection(2)}
        style={{
          textAlign: jumpColDef?.align,
          cursor: "pointer",
          fontFamily: "Lato,sans-serif",
          fontWeight: 400,
          lineHeight: 1.43,
          padding: 8,
          fontSize: 14
        }}
      />
    )
  }
  return (
    <th
      key={index}
      onClick={() => updateDirection(2)}
      style={{ cursor: "pointer", textAlign: jumpColDef?.align }}
    >
      <Typography>{label}</Typography>
    </th>
  )
}

HeadCell.propTypes = {
  columnMeta: PropTypes.object.isRequired,
  updateDirection: PropTypes.func.isRequired,
  jumpColDef: PropTypes.any
}

HeadCell.defaultProps = {
  jumpColDef: undefined
}

export default HeadCell
